// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import "../styles/ClaimResult.css";

const AiConfidenceMeter = (counts) => {
  console.log(counts);

  const combinedData = [
    { name: "Valid", value: counts.counts["valid"] || 0, fill: "#1a936f" },
    {
      name: "Ambiguous",
      value: counts.counts["ambiguous"] || 0,
      fill: "#f4d35e",
    },
    { name: "Invalid", value: counts.counts["invalid"] || 0, fill: "#ee6c4d" },
  ];

  return (
    <div className="ai-meter-box">
      <div className="ai-meter-chart">
        <PieChart width={280} height={250}>
          <Pie
            data={combinedData}
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={100}
            dataKey="value"
            paddingAngle={3}
          >
            {combinedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip />
          <Legend verticalAlign="bottom" height={32} />
        </PieChart>
      </div>

      <div className="ai-meter-note">
        Based on <strong>{counts.counts["total"]}</strong> records analyzed:
        <br />✅ Valid: <strong>{counts.counts["valid"] || 0}</strong>, ❓
        Ambiguous: <strong>{counts.counts["ambiguous"] || 0}</strong>, ❌
        Invalid: <strong>{counts.counts["invalid"] || 0}</strong>
      </div>
    </div>
  );
};

export default AiConfidenceMeter;
